import { VendaCategoria } from '../models';
import { makeCrudObject } from './api';

export default makeCrudObject<VendaCategoria>('venda-categorias');
